export enum FailedAutoLinkAction {
	FolderCreation = 0,
	RedirectToRejectBox = 1,
}
